/** @format */

import React, { FunctionComponent, ReactElement, useEffect, useState } from 'react';
import { PlatformPoolFile } from '../../../interfaces/collections/PlatformPoolFilesCollectionInterface';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import CustomTextButtom from '../../../components/Buttons/CustomTextButton';
import I18n from '../../../components/Translate/I18n';
import { usePlatformResellerHeaders, usePlatformResellerList } from '../../../modules/lib/hooks/usePlatformResellerHooks';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import { SimpleSelect } from '../../../components/Adescom/SimpleSelect';
import CustomInputExtNumber from '../../../components/CustomInput/CustomInputExtNumber';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { useDispatch } from 'react-redux';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';

const _ = require('underscore');

type PlatformPoolFileChangeType = {
    platformPoolFile: PlatformPoolFile | null;
    showMainLoader: (show: boolean) => void;
    reloadList: (relaod: boolean) => void;
    open: boolean;
    closeCallback: () => void;
};

export const PlatformPoolFileChange: FunctionComponent<PlatformPoolFileChangeType> = ({
    platformPoolFile,
    showMainLoader,
    reloadList,
    open,
    closeCallback,
}): ReactElement => {
    const dispatch = useDispatch();
    const [rangeFrom, setRangeFrom] = useState<string | null>(null);
    const [rangeTo, setRangeTo] = useState<string | null>(null);
    const [platformResellerId, setPlatformResellerId] = useState<number | null>(null);
    const platformResellerList = usePlatformResellerList([]);
    const platformResellerHeader = usePlatformResellerHeaders(platformResellerList);

    useEffect(() => {
        setRangeFrom(platformPoolFile?.rangeFrom ?? '');
        setRangeTo(platformPoolFile?.rangeTo ?? '');
        setPlatformResellerId(platformPoolFile?.platformResellerId ?? -1);
    }, [platformPoolFile]);

    const onChangeEvent = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const value = event.target.value;
        const field = event.target.name;
        switch (field) {
            case 'rangeFrom':
                setRangeFrom(value);
                break;
            case 'rangeTo':
                setRangeTo(value);
                break;
            default:
                break;
        }
    };

    const setPlatformResellerCallback = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        setPlatformResellerId(parseInt(event.target.value));
    };

    const confirmCallback = (): void => {
        const itemLoader = new ItemLoaders(dispatch);
        const pool = _.clone(platformPoolFile);
        if (platformPoolFile?.poolType !== 'ip') {
            pool.platformResellerId = platformResellerId;
        }
        pool.rangeTo = rangeTo;
        pool.rangeFrom = rangeFrom;
        if (platformPoolFile && platformPoolFile['@id']) {
            showMainLoader(true);
            itemLoader.putWithCallback(
                FormGeneralHelper.getByUri(platformPoolFile['@id']),
                'put_platform_pool_file_custom',
                pool,
                (data: PlatformPoolFile): void => {
                    showMainLoader(false);
                    reloadList(true);
                    closeCallback();
                },
                { dispatchAfterCallback: false, propagateDataToCallback: true }
            );
        }
    };

    return (
        <Dialog open={open} maxWidth="md">
            <DialogTitle>
                <I18n trans="pools:msisdn.change_params" />
            </DialogTitle>
            <DialogContent>
                <GridContainer>
                    {platformPoolFile?.poolType !== 'ip' && (
                        <GridItem xs={12}>
                            <SimpleSelect
                                label="pools:msisdn.choose_partner"
                                required={true}
                                elements={platformResellerHeader ?? []}
                                fieldName="platformResellerId"
                                dispatchName={'none'}
                                selectedValue={platformResellerId ?? undefined}
                                callback={setPlatformResellerCallback}
                            />
                        </GridItem>
                    )}
                    <GridItem xs={6}>
                        <CustomInputExtNumber
                            formControlProps={{ fullWidth: true }}
                            required={false}
                            labelText="pools:msisdn.range_from"
                            name="rangeFrom"
                            value={rangeFrom}
                            onChange={onChangeEvent}
                        />
                    </GridItem>
                    <GridItem xs={6}>
                        <CustomInputExtNumber
                            formControlProps={{ fullWidth: true }}
                            required={false}
                            labelText="pools:msisdn.range_to"
                            name="rangeTo"
                            value={rangeTo}
                            onChange={onChangeEvent}
                        />
                    </GridItem>
                </GridContainer>
            </DialogContent>
            <DialogActions>
                <CustomTextButtom callback={closeCallback} callbackParam={{}} label="general:common.close" size="sm" />
                <CustomTextButtom callback={confirmCallback} callbackParam={{}} label="pools:msisdn.save_change" size="sm" />
            </DialogActions>
        </Dialog>
    );
};
